module.exports = __webpack_public_path__ + "img/exclamation-triangle.90c3312e.svg";